import { AxiosResponse } from 'axios';

import { axiosInstance } from './axios.config';
import { ResponseAuth, ResponseREST } from './response.type';

interface ResponseSuccessPostAuth extends ResponseREST {
  data: ResponseAuth;
}

interface Body {
  clientId: string;
  clientSecret: string;
}

export const postAuth = async (body: Body): Promise<ResponseSuccessPostAuth> => {
  return axiosInstance
    .post('authentication/oauth/token', body)
    .then((res: AxiosResponse<ResponseSuccessPostAuth>) => res.data)
    .catch((err) => err);
};
